export const DEFAULT_VALUE = Symbol("Required context default value");
export const ERROR_MESSAGE =
	"[react-required-context] `useContext` is used outside of `Provider` of context";
